export const TITLE = "Bajaj RE E-TEC 9.0 Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Bajaj RE E-TEC 9.0 price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "bajaj electric auto rickshaw price, bajaj electric auto rickshaw, bajaj electric auto price, bajaj electric auto launch date, bajaj re electric auto rickshaw price, bajaj electric auto, bajaj electric auto rickshaw launch date, bajaj auto electric vehicles, bajaj electric auto on road price, bajaj auto electric, bajaj electric auto rickshaw price in india, electric auto bajaj, electric bajaj auto, bajaj electric auto price in chennai, bajaj electric auto price in kerala, bajaj re electric auto rickshaw",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Bajaj/re-e-tec",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Bajaj/re-e-tec",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Bajaj RE E-TEC 9.0 Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Bajaj RE E-TEC 9.0 price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Bajaj RE E-TEC 9.0 price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Bajaj RE E-TEC 9.0 Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Bajaj/re-e-tec",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADER = "Highlights of Bajaj electric auto rickshaw";

export const SUB_TEXT =
  "The Bajaj RE E TEC 9.0 auto rickshaw offers a remarkable driving experience with its 8.9 kWh battery, providing an impressive range of 178 km. Its convenient onboard charger allows for easy charging anywhere. The 2-speed automatic transmission enhances gradability on all roads, while the advanced PMS motor maximizes overall range and gradability. With big tubeless radial tyres and a robust chassis, this auto rickshaw ensures a comfortable and durable ride with minimal maintenance requirements.";

export const BENEFITS_HEADER = "Benefits of Bajaj RE E TEC 9.0";

export const VEHICLE_FEATURE_HEADER = "Features of Bajaj RE E TEC 9.0";

export const BRAND_DEALER_HEADER =
  "Bajaj electric auto rickshaw showroom near me";

export const BRAND_DEALER_DESCRIPITION =
  "You may find many Bajaj electric auto dealers near you but if you want the best EV buying and owning experience, you must visit Turno, India’s No.1 EV Dealer. At Turno, we don’t only sell EVs, we also provide excellent after-sale support such as assured vehicle buyback, dedicated relationship manager, arranging roadside assistance and additional EV services.";

export const FAQ_HEADER_TEXT = "FAQs on Bajaj electric auto rickshaw";

export const H1_HEADING = "Bajaj RE E-TEC 9.0";

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Bajaj/re-e-tec";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Bajaj RE E-TEC 9.0" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Bajaj RE E-TEC 9.0",
      item: VEHICLE_LINK,
    },
  ],
};